import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as ProjectsActions from './projects.actions';
import * as ProjectsFeature from './projects.reducer';
import * as ProjectsSelectors from './projects.selectors';

@Injectable()
export class ProjectsFacade {
  private readonly store = inject(Store);

  myAllProjectsList$ = this.store.pipe(select(ProjectsSelectors.GetMyAllProjectsList));
  getMyAllProductProjectsList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProductProjectsList)
  );
  defalutMaterialProjectList$ = this.store.pipe(
    select(ProjectsSelectors.GetDefalutMaterialProjectList)
  );
  getMyAllProjectsScenarioList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProjectsScenarioList)
  );
  getMyAllProjectsScenarioConsumerList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProjectsScenarioConsumerList)
  );
  getMyAllProjectsScenarioReatilList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProjectsScenarioReatilList)
  );
  getMyAllProjectsScenarioWholesaleList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProjectsScenarioWholesaleList)
  );
  getMyAllProjectsPackMaterialList$ = this.store.pipe(
    select(ProjectsSelectors.GetMyAllProjectsPackMaterialList)
  );
  getMyAllProjectsPackConversionList$ = this.store.pipe(
    select(ProjectsSelectors.GetmyAllProjectsPackConversionList)
  );
  projectPackMaterialTransportScenarioList$ = this.store.pipe(
    select(ProjectsSelectors.GetTransportScenarioListForPackMaterial)
  );
  getTransportScenarioListFordistance$ = this.store.pipe(
    select(ProjectsSelectors.GetTransportScenarioListFordistance)
  );
  getCustomTransoportScenarioDetailViewModels$ = this.store.pipe(
    select(ProjectsSelectors.GetCustomTransoportScenarioDetailViewModels)
  );
  getConversionList$ = this.store.pipe(select(ProjectsSelectors.GetProjectPackConversionList));
  projectFillingList$ = this.store.pipe(select(ProjectsSelectors.GetProjectFillingList));
  fillingProcessData$ = this.store.pipe(select(ProjectsSelectors.GetFillingProcessList));
  getTransportScenarioEolDataListForRetail$ = this.store.pipe(
    select(ProjectsSelectors.GetTransportScenarioEolDataListForRetail)
  );
  getTransportScenarioListForRetail$ = this.store.pipe(
    select(ProjectsSelectors.GetTransportScenarioListForRetail)
  );
  getTransportScenarioListForDistancePackRetail$ = this.store.pipe(
    select(ProjectsSelectors.GetTransportScenarioListForDistancePackRetail)
  );
  locationProcessData$ = this.store.pipe(select(ProjectsSelectors.GetLocationList));
  distanceProcessData$ = this.store.pipe(select(ProjectsSelectors.GetDistanceList));
  locationProcessProductData$ = this.store.pipe(select(ProjectsSelectors.GetLocationProductList));
  distanceProcessProductData$ = this.store.pipe(select(ProjectsSelectors.GetDistanceProductList));
  freightProcessData$ = this.store.pipe(select(ProjectsSelectors.GetFreightList));
  freightProcessProductData$ = this.store.pipe(select(ProjectsSelectors.GetFreightProductList));
  componentProcessData$ = this.store.pipe(select(ProjectsSelectors.GetComponentTransport));
  productProcessData$ = this.store.pipe(select(ProjectsSelectors.GetProductTransport));
  getresetEolList$ = this.store.pipe(select(ProjectsSelectors.GetresetEolList));
  getEolTotalError$ = this.store.pipe(select(ProjectsSelectors.GetEolTotalError));
  locationWholesale$ = this.store.pipe(select(ProjectsSelectors.GetWholesaleLocationList));
  distanceWholesale$ = this.store.pipe(select(ProjectsSelectors.GetWholesaleDistanceList));
  freightWholesaleProcessData$ = this.store.pipe(select(ProjectsSelectors.GetFreightWholesaleList));
  errMessage$ = this.store.pipe(select(ProjectsSelectors.showErrorMsgProject));
  errMsgReuseEOL$ = this.store.pipe(select(ProjectsSelectors.showReuseEOLErr));
  storeerr$ = this.store.pipe(select(ProjectsSelectors.storeerr));
  replicaLocation$ = this.store.pipe(select(ProjectsSelectors.GetReplicaLocationList));
  replicaDistance$ = this.store.pipe(select(ProjectsSelectors.GetReplicaDistanceList));
  getProductIngredient$ = this.store.pipe(select(ProjectsSelectors.GetProductIngredient));
  getIngredientItems$ = this.store.pipe(select(ProjectsSelectors.getIngredientItems));
  organizationMapItems$ = this.store.pipe(select(ProjectsSelectors.organizationItemsSelector));
  organizationPreferencesMapItems$ = this.store.pipe(
    select(ProjectsSelectors.organizationPreferencesItemsSelector)
  );
  getIngredientTransportItems$ = this.store.pipe(
    select(ProjectsSelectors.getIngredientTransportItems)
  );
  getManufacturProcess$ = this.store.pipe(select(ProjectsSelectors.getManufacturProcess));
  errorMessageForProductIngredient$ = this.store.pipe(
    select(ProjectsSelectors.errorMessageForProductIngredient)
  );
  productManufactureList$ = this.store.pipe(select(ProjectsSelectors.ProductManufactureList));
  productIngredientDistance$ = this.store.pipe(select(ProjectsSelectors.productIngredientDistance));
  productIngredientistanceProcessList$ = this.store.pipe(
    select(ProjectsSelectors.productIngredientistanceProcessList)
  );
  projectNameForBreadcrumb$ = this.store.pipe(select(ProjectsSelectors.projectName));
  getDefalutOrgReportingList$ = this.store.pipe(
    select(ProjectsSelectors.GetDefalutOrgReportingList)
  );
  //transport pre retail
  getEolPreRetailData$ = this.store.pipe(select(ProjectsSelectors.getEolPreRetailData));
  getPreRetailReuseActionList$ = this.store.pipe(
    select(ProjectsSelectors.getPreRetailReuseActionList)
  );
  getTransportScenarioManudalLocationList$ = this.store.pipe(
    select(ProjectsSelectors.getTransportScenarioManudalLocationList)
  );
  getTransportScenarioManualDistanceList$ = this.store.pipe(
    select(ProjectsSelectors.getTransportScenarioManualDistanceList)
  );
  getComponentPreRetailList$ = this.store.pipe(select(ProjectsSelectors.getComponentPreRetailList));
  getEolResueList$ = this.store.pipe(select(ProjectsSelectors.GetEolResueList));
  getEolConsumerList$ = this.store.pipe(select(ProjectsSelectors.GetEolConsumerList));
  duplicateManualLocation$ = this.store.pipe(select(ProjectsSelectors.duplicateManualLocation));
  duplicateManualDistance$ = this.store.pipe(select(ProjectsSelectors.duplicateManualDistance));
  dupliatePreRetailActionList$ = this.store.pipe(
    select(ProjectsSelectors.dupliatePreRetailActionList)
  );
  orgReportingError$ = this.store.pipe(select(ProjectsSelectors.orgReportingErrorSelector));

  packageEOLRetail$ = this.store.pipe(select(ProjectsSelectors.packEOLRetail));
  packageEOLConsumer$ = this.store.pipe(select(ProjectsSelectors.packEOLConsumer));

  productMixList$ = this.store.pipe(select(ProjectsSelectors.productMixData));
  productMixErrorStr$ = this.store.pipe(select(ProjectsSelectors.productMixError));
  distanceErrorProject$ = this.store.pipe(select(ProjectsSelectors.distanceErrorProject));
  distanceErrorProjectProduct$ = this.store.pipe(
    select(ProjectsSelectors.distanceErrorProjectProduct)
  );
  checkUpdateForProdMix$ = this.store.pipe(select(ProjectsSelectors.checkProdMixSelector));
  checkUpdateActionForOrganization$ = this.store.pipe(
    select(ProjectsSelectors.checkUpdateActionForOrganizationSelector)
  );
  checkUpdateActionInterpretation$ = this.store.pipe(
    select(ProjectsSelectors.checkUpdateActionInterpretation)
  );
  checkUpdateActionIngredient$ = this.store.pipe(
    select(ProjectsSelectors.checkUpdateActionIngredient)
  );

  dataAnalysisTechnology$ = this.store.pipe(select(ProjectsSelectors.updateTechnology));
  checkUpdateActionForReuse$ = this.store.pipe(
    select(ProjectsSelectors.checkUpdateActionForReuseSelector)
  );

  getMyAllProjectList(payload: any) {
    this.store.dispatch(ProjectsActions.getAllMyProjectList({ myProjectListPaylaod: payload }));
  }
  getAllMyProductProjectList(payload: any) {
    this.store.dispatch(
      ProjectsActions.getAllMyProductProjectList({ myProductProjectListPaylaod: payload })
    );
  }
  getProductIngredientList(productId: any, payload: any) {
    this.store.dispatch(
      ProjectsActions.getProductIngredientList({
        productId: productId,
        myProductIngredientListPaylaod: payload,
      })
    );
  }

  openAddEditMyProjectModal(projectId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      ProjectsActions.openAllMyProjectModal({
        projectId: projectId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  openAddEditMyProductProjectModal(productId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      ProjectsActions.openAddEditMyProductProjectModal({
        productId: productId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  copyMyProjectAction(action: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(ProjectsActions.allMyProjectCopyModal({ action, actionLabel, pathName }));
  }

  deleteMyProjectAction(action: any, pathName: any, pageName?: string) {
    this.store.dispatch(ProjectsActions.deleteDataMyProject({ action, pathName, pageName }));
  }

  deleteMyProjectData(payload: any, pathName: any) {
    this.store.dispatch(ProjectsActions.deleteMyProjectData({ payload, pathName }));
  }

  addEditMyProject(payload: any, isEdit?: any) {
    this.store.dispatch(
      ProjectsActions.addEditMyProject({ myProjectDataPayload: payload, isEdit: isEdit })
    );
  }

  addEditMyProjectPackMaterial(payload: any, pathName: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.addEditMyProjectPackMaterial({
        myProjectDataPayload: payload,
        pathName: pathName,
        scenarioId: scenarioId,
      })
    );
  }

  addEditProductIngredient(payload: any, pathName: any, productId: any) {
    this.store.dispatch(
      ProjectsActions.addEditProductIngredient({
        myProductIngredientDataPayload: payload,
        pathName: pathName,
        productId: productId,
      })
    );
  }

  copyMyProject(payload: any) {
    this.store.dispatch(ProjectsActions.copyMyProject({ copyMyProjectDataPayload: payload }));
  }

  newMyProjectAction(data: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.newMyProjectAction({
        newMaterialData: data,
        action: action,
        ingredientIndex: ingredientIndex,
      })
    );
  }
  newMyProjectOrgReporting(data: any, action: any) {
    this.store.dispatch(ProjectsActions.addOrgYear({ process: data, action: action }));
  }

  clearDefaultMaterial() {
    this.store.dispatch(ProjectsActions.clearNewMyProjectAction());
  }
  clearProduct() {
    this.store.dispatch(ProjectsActions.clearProduct());
  }

  newMyProjectActionSuccess(data: any) {
    this.store.dispatch(
      ProjectsActions.newMyProjectActionSuccess({ newDefalutMaterialList: data })
    );
  }

  GetProjectScenarioList(payload: any, projectId: any, scenarioTypeId: any) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectScenarioList({
        myProjectListPaylaod: payload,
        projectId: projectId,
        scenarioTypeId: scenarioTypeId,
      })
    );
  }

  openNewAddScenario(scenarioId: any, actionLabel: any, projectId: any, scenarioTypeId: any) {
    this.store.dispatch(
      ProjectsActions.openAllMyProjectScenarioModal({
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        projectId: projectId,
        scenarioTypeId: scenarioTypeId,
      })
    );
  }

  openNewAddProjectMaterial(
    scenarioId: any,
    id: any,
    actionLabel: any,
    isMaterial: any,
    pathName: any
  ) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectMaterialModal({
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        id: id,
        isMaterial: isMaterial,
        pathName: pathName,
      })
    );
  }

  bookMarkComponentDataBind(data: any) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectMaterialModalSuccess({
        openNewAddProjectMaterialModalData: data,
      })
    );
  }

  openNewAddProjectManufacturing(
    scenarioId: any,
    actionLabel: any,
    projectId: any,
    scenarioTypeId: any
  ) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectManufactureModal({
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        projectId: projectId,
        scenarioTypeId: scenarioTypeId,
      })
    );
  }

  openNewAddProjectFillData(scenarioId: any, id: any, actionLabel: any, projectId: any) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectFillDataModal({
        scenarioId: scenarioId,
        id: id,
        actionLabel: actionLabel,
        projectId: projectId,
      })
    );
  }

  GetProjectScenarioWholesaleList(
    payload: any,
    storagetypeId: any,
    scenarioId: any,
    projectId: any
  ) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectScenarioWholesaleList({
        myProjectScenarioWholesaleListPaylaod: payload,
        storagetypeId: storagetypeId,
        scenarioId: scenarioId,
        projectId: projectId,
      })
    );
  }

  openNewAddProjectScenarioConsumer(
    scenarioId: any,
    id: any,
    actionLabel: any,
    storageTypeId: any,
    pathName: any
  ) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectScenarioConsumer({
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        id: id,
        storageTypeId: storageTypeId,
        pathName: pathName,
      })
    );
  }

  addEditScenario(payload: any) {
    this.store.dispatch(ProjectsActions.addEditScenario({ scenarioPayload: payload }));
  }

  deleteProjectData(
    scenarioId: any,
    pathName: any,
    projectId?: any,
    scenarioTypeId?: any,
    pageName?: any
  ) {
    this.store.dispatch(
      ProjectsActions.deleteProjectData({
        id: scenarioId,
        pathName: pathName,
        projectId: projectId,
        scenarioTypeId: scenarioTypeId,
        pageName: pageName,
      })
    );
  }

  openProjectDeleteModal(
    id: any,
    pathName: any,
    projectId?: any,
    scenarioTypeId?: any,
    scenarioId?: any
  ) {
    this.store.dispatch(
      ProjectsActions.openProjectDeleteModal({
        id: id,
        pathName: pathName,
        projectId: projectId,
        scenarioTypeId: scenarioTypeId,
        scenarioId: scenarioId,
      })
    );
  }

  openCopyProjectScenarioModal(scenarioId?: any, actionLabel?: any) {
    this.store.dispatch(
      ProjectsActions.openCopyProjectScenario({ scenarioId: scenarioId, actionLabel: actionLabel })
    );
  }

  copyProjectScenario(payload: any) {
    this.store.dispatch(ProjectsActions.copyScenario({ copyScenarioPayload: payload }));
  }

  //pack material
  GetProjectPackMaterialList(payload: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectPackMaterialList({
        myProjectListPackMaterialPaylaod: payload,
        scenarioId: scenarioId,
      })
    );
  }

  transportScenarioActions(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.addTransportScenarioForPackMaterial({ transport, action, ingredientIndex })
    );
  }

  transportScenarioActionsFordistance(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.addTransportScenarioForDistancePackMaterial({
        transport,
        action,
        ingredientIndex,
      })
    );
  }
  packMaterialConversionProcess(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.addPackMaterialConversion({ transport, action, ingredientIndex })
    );
  }
  clearTransportScenario() {
    this.store.dispatch(ProjectsActions.clearaddTransportScenarioForPackMaterial());
  }
  clearaddTransportScenarioForPackMaterialForConversion() {
    this.store.dispatch(ProjectsActions.clearaddTransportScenarioForPackMaterialForConversion());
  }
  clearManualTransportDistanceError() {
    this.store.dispatch(ProjectsActions.clearManualTransportDistanceError());
  }
  clearaddTransportScenarioForPackMaterialForCustom() {
    this.store.dispatch(ProjectsActions.clearaddTransportScenarioForPackMaterialForCustom());
  }

  copyPackMaterialCopy(action: any, lableName: any, pathName: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.projectPackMaterialCopy({ action, lableName, pathName, scenarioId })
    );
  }
  projectPackMaterialCopySave(action: any, scenarioId: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.projectPackMaterialCopySave({
        payload: action,
        scenarioId: scenarioId,
        pathName: pathName,
      })
    );
  }
  // pack conversion list
  getProjectPackConversionList(payload: any, scenarioId: any, projectId: any) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectPackConversionList({
        myProjectListPackConversionPaylaod: payload,
        scenarioId: scenarioId,
        projectId: projectId,
      })
    );
  }

  GetProjectFillingList(scenarioId: any, payload: any, projectId: any) {
    this.store.dispatch(
      ProjectsActions.getProjectFillingList({
        scenarioId: scenarioId,
        projectFillingPayload: payload,
        projectId: projectId,
      })
    );
  }

  addEditProjectFilling(payload: any) {
    this.store.dispatch(ProjectsActions.addEditProjectFilling({ fillingPayload: payload }));
  }

  fillingProcessActions(filling: any, action: any) {
    this.store.dispatch(ProjectsActions.addFillingProcess({ filling, action }));
  }

  clearFillingProcess() {
    this.store.dispatch(ProjectsActions.clearaddFillingProcess());
  }

  // pack retail
  GetProjectScenarioRetailList(payload: any, storagetypeId: any, scenarioId: any, projectId: any) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectScenarioRetailList({
        myProjectScenarioReatilListPaylaod: payload,
        storagetypeId: storagetypeId,
        scenarioId: scenarioId,
        projectId: projectId,
      })
    );
  }
  openNewAddProjectRetail(
    scenarioId: any,
    id: any,
    actionLabel: any,
    storageTypeId: any,
    pathName: any
  ) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectRetaiModal({
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        id: id,
        storageTypeId: storageTypeId,
        pathName: pathName,
      })
    );
  }

  //For Transport filling in location
  locationProcessActions(location: any, action: any) {
    this.store.dispatch(ProjectsActions.addLocationProcess({ location, action }));
  }
  addLocationProcessIngredient(location: any, action: any) {
    // For ingredient inline edit
    this.store.dispatch(ProjectsActions.addLocationProcessIngredient({ location, action }));
  }
  locationProductProcessActions(locationProduct: any, action: any) {
    this.store.dispatch(ProjectsActions.addLocationProcessProduct({ locationProduct, action }));
  }

  clearLocationProcess() {
    this.store.dispatch(ProjectsActions.clearLocationProcess());
  }
  clearAllReplicaList() {
    this.store.dispatch(ProjectsActions.clearAllReplicaList());
  }

  clearLocationProcessProduct() {
    this.store.dispatch(ProjectsActions.clearaddLocationProcessProduct());
  }

  fillingTransportProcess(location: any, action: any) {
    // For filling inline edit
    this.store.dispatch(ProjectsActions.addLocationProcess({ location, action }));
  }

  packRetailTransportScenarioManualLocationActions(
    transport: any,
    action: any,
    ingredientIndex?: any
  ) {
    this.store.dispatch(
      ProjectsActions.addTransportScenarioForPackRetail({ transport, action, ingredientIndex })
    );
  }
  packRetailTransportScenarioActionsFordistance(
    transport: any,
    action: any,
    ingredientIndex?: any
  ) {
    this.store.dispatch(
      ProjectsActions.addTransportScenarioForDistancePackRetail({
        transport,
        action,
        ingredientIndex,
      })
    );
  }
  addEditMyProjectPackRetail(payload: any, pathName: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.addEditMyProjectPackRetail({
        myProjectDataPayload: payload,
        pathName: pathName,
        scenarioId: scenarioId,
      })
    );
  }
  clearTransportScenarioForPackRetail() {
    this.store.dispatch(ProjectsActions.clearaddTransportScenarioForPackRetail());
  }
  clearaddTransportScenarioForPackRetailForCustom() {
    this.store.dispatch(ProjectsActions.clearaddTransportScenarioForPackRetailForCustom());
  }
  packRetailProcess(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(ProjectsActions.addPackRetailEol({ transport, action, ingredientIndex }));
  }

  distanceTransportActions(distance: any, action: any, isDistance?: any) {
    // For project filling
    this.store.dispatch(ProjectsActions.addDistanceTransport({ distance, action, isDistance }));
  }

  addDistanceTransportIngredeint(distance: any, action: any, isDistance?: any) {
    // For ingredient
    this.store.dispatch(
      ProjectsActions.addDistanceTransportIngredeint({ distance, action, isDistance })
    );
  }

  clearDistanceProcess() {
    this.store.dispatch(ProjectsActions.clearaddDistanceTransport());
  }

  distanceTransportProductActions(distanceProduct: any, action: any, isDistance?: any) {
    // For project filling
    this.store.dispatch(
      ProjectsActions.addDistanceTransportProduct({ distanceProduct, action, isDistance })
    );
  }

  clearDistanceProcessProduct() {
    this.store.dispatch(ProjectsActions.clearaddDistanceProductTransport());
  }

  customFreightActions(freight: any, isCustomSiteTransport: any) {
    this.store.dispatch(ProjectsActions.getCustomFreight({ freight, isCustomSiteTransport }));
  }

  getCustomFreightForIngredient(freight: any, isCustomSiteTransport: any) {
    this.store.dispatch(
      ProjectsActions.getCustomFreightForIngredient({ freight, isCustomSiteTransport })
    );
  }

  clearFreightProcess() {
    this.store.dispatch(ProjectsActions.clearCustomFreight());
  }

  customFreightProductActions(freightProduct: any, isCustomSiteTransport: any) {
    this.store.dispatch(
      ProjectsActions.getCustomFreightProduct({ freightProduct, isCustomSiteTransport })
    );
  }

  clearFreightProcessProduct() {
    this.store.dispatch(ProjectsActions.clearCustomFreightProduct());
  }

  componentTransportActions(component: any, action: any) {
    this.store.dispatch(ProjectsActions.addComponent({ component, action }));
  }

  productTransportActions(product: any, action: any) {
    this.store.dispatch(ProjectsActions.addProduct({ product, action }));
  }

  clearComponentTransport() {
    this.store.dispatch(ProjectsActions.clearComponent());
  }

  resetEolData() {
    this.store.dispatch(ProjectsActions.resetEolData());
  }
  clearTotalEolMessage() {
    this.store.dispatch(ProjectsActions.clearTotalEolMessage());
  }

  // pack consumer
  GetProjectScenarioConsumerList(
    payload: any,
    storagetypeId: any,
    scenarioId: any,
    projectId: any
  ) {
    this.store.dispatch(
      ProjectsActions.getAllMyProjectScenarioConsumerList({
        myProjectScenarioConsumerListPaylaod: payload,
        storagetypeId: storagetypeId,
        scenarioId: scenarioId,
        projectId: projectId,
      })
    );
  }

  addEditProjectWholesale(payload: any) {
    this.store.dispatch(ProjectsActions.addEditProjectWholesale({ wholesalePayload: payload }));
  }

  openNewAddProjectWholesaleData(
    scenarioId: any,
    id: any,
    storageTypeId: any,
    actionLabel: any,
    projectId: any
  ) {
    this.store.dispatch(
      ProjectsActions.openNewAddProjectWholesaleDataModal({
        scenarioId: scenarioId,
        id: id,
        storageTypeId: storageTypeId,
        actionLabel: actionLabel,
        projectId: projectId,
      })
    );
  }

  // For wholesale
  locationProcessWholesaleActions(locationWholesale: any, action: any) {
    this.store.dispatch(ProjectsActions.addLocationWholesale({ locationWholesale, action }));
  }

  distanceWholesaleActions(wholesaleDistance: any, action: any, isDistance?: any) {
    this.store.dispatch(
      ProjectsActions.addDistanceWholesale({ wholesaleDistance, action, isDistance })
    );
  }

  clearDistanceWholesale() {
    this.store.dispatch(ProjectsActions.clearaddDistanceWholesale());
  }

  clearLocationWholesale() {
    this.store.dispatch(ProjectsActions.clearaddLocationWholesale());
  }

  clearFreightWholesale() {
    this.store.dispatch(ProjectsActions.clearCustomFreightWholesale());
  }

  customFreightWholesaleActions(freightWholesale: any, isCustomSiteTransport: any) {
    this.store.dispatch(
      ProjectsActions.getCustomFreightWholesale({ freightWholesale, isCustomSiteTransport })
    );
  }

  wholesaleInlineTransportProcess(locationWholesale: any, action: any) {
    // For wholesale inline edit
    this.store.dispatch(ProjectsActions.addLocationWholesale({ locationWholesale, action }));
  }

  inlineDataEdit(projectInlineData: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.inlineEditProject({
        projectInlineData: projectInlineData,
        pathName: pathName,
      })
    );
  }

  inlineDataEditForProject(projectInlinePayload: any, scenarioId: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.inlineDataEditForProject({
        projectInlinePayload: projectInlinePayload,
        scenarioId: scenarioId,
        pathName: pathName,
      })
    );
  }

  inlineDataEditForProjectMaterial(projectInlinePayload: any, scenarioId: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.inlineDataEditForProjectMaterial({
        projectInlinePayload: projectInlinePayload,
        scenarioId: scenarioId,
        pathName: pathName,
      })
    );
  }

  inlineDataEditScenarioName(scenarioInlineData: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.inlineEditScenarioName({
        scenarioInlineData: scenarioInlineData,
        pathName: pathName,
      })
    );
  }

  addEditMyProductProject(payload: any) {
    this.store.dispatch(
      ProjectsActions.addEditMyProductProject({ myProductProjectDataPayload: payload })
    );
  }

  openModalProductIngredient(productId: any, id: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.openModalProductIngredientModal({
        productId: productId,
        actionLabel: actionLabel,
        id: id,
        pathName: pathName,
      })
    );
  }

  proudctIngredientProcess(ingredient: any, action: any, colId?: any, rowId?: any) {
    this.store.dispatch(
      ProjectsActions.proudctIngredientProcess({ ingredient, action, colId, rowId })
    );
  }

  organizationDataMapProcess(organization: any, action: any, colId?: any, rowId?: any) {
    this.store.dispatch(
      ProjectsActions.organizationDataMapProcess({ organization, action, colId, rowId })
    );
  }

  organizationPreferencesDataMapProcess(organization: any, action: any, colId?: any, rowId?: any) {
    this.store.dispatch(
      ProjectsActions.organizationPreferencesDataMapProcess({ organization, action, colId, rowId })
    );
  }

  proudctIngredientTransportProcess(ingredient: any, action: any) {
    this.store.dispatch(ProjectsActions.proudctIngredientTransportProcess({ ingredient, action }));
  }

  proudctIngredientManufactureProcess(ingredient: any, action: any) {
    this.store.dispatch(
      ProjectsActions.proudctIngredientManufactureProcess({ ingredient, action })
    );
  }

  clearProudctIngredientProcess() {
    this.store.dispatch(ProjectsActions.clearProudctIngredientProcess());
  }

  clearProudctIngredientProcessError() {
    this.store.dispatch(ProjectsActions.clearProudctIngredientProcessError());
  }

  getProductManufactureList(productId: any, payload: any) {
    this.store.dispatch(
      ProjectsActions.getProductManufactureList({
        productId: productId,
        myProductManufactureListPaylaod: payload,
      })
    );
  }
  storeProjectNameForBreadcrumb(projectName: any) {
    this.store.dispatch(ProjectsActions.projectNameForBreadCrumbs({ projectName: projectName }));
  }

  clearProjectName() {
    this.store.dispatch(ProjectsActions.clearProjectNameForBreadCrumbs());
  }
  projectEOLReuseList(payload: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.projectEOLReuseList({ payload: payload, scenarioId: scenarioId })
    );
  }

  projectEOLConsumerist(payload: any, scenarioId: any) {
    this.store.dispatch(
      ProjectsActions.projectEOLConsumerist({ payload: payload, scenarioId: scenarioId })
    );
  }

  // eol pre retail

  openAddEditEolPreRetail(
    scenarioId: any,
    reuseFillingId: string,
    actionLabel: string,
    pathName: any,
    storagetypeId: number,
    reuseType?: any
  ) {
    this.store.dispatch(
      ProjectsActions.openAddEditEolPreRetail({
        scenarioId: scenarioId,
        reuseFillingId: reuseFillingId,
        actionLabel: actionLabel,
        pathName: pathName,
        storagetypeId: storagetypeId,
        reuseType: reuseType,
      })
    );
  }

  addEditEolPreRetail(preEolRetailPayload: any, scenarioId: any, pathName: any) {
    this.store.dispatch(
      ProjectsActions.addEditEolPreRetail({
        preEolRetailPayload: preEolRetailPayload,
        scenarioId: scenarioId,
        pathName: pathName,
      })
    );
  }

  // transport pre retail
  preRetailReuseAction(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.preRetailReuseAction({ transport, action, ingredientIndex })
    );
  }
  preRetailReuseSetData(list: any, transportId: any, transportData: any) {
    this.store.dispatch(
      ProjectsActions.preRetailReuseSetData({
        preRetailReuseActionList: list,
        transportId,
        transportData,
      })
    );
  }
  manudaLocationPreRetail(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.manudaLocationPreRetail({ transport, action, ingredientIndex })
    );
  }
  manudaDistancePreRetail(transport: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      ProjectsActions.manudaDistancePreRetail({ transport, action, ingredientIndex })
    );
  }
  clearEolPreReatil(text?: string) {
    this.store.dispatch(ProjectsActions.clearEolPreReatil({ resetText: text }));
  }
  clearPreRetailReuseActionList() {
    this.store.dispatch(ProjectsActions.clearPreRetailReuseActionList());
  }

  eolPreRetailAddComponent(component: any, action: any, isInline?: any, rowIdx?: any) {
    this.store.dispatch(
      ProjectsActions.eolPreRetailAddComponent({ component, action, isInline, rowIdx })
    );
  }

  updateOrgYearActions(process: any, action: any, processIndex?: any, nodeId?: any, colId?: any) {
    this.store.dispatch(
      ProjectsActions.updateOrgYear({ process, action, processIndex, nodeId, colId })
    );
  }

  addEolViewModalData(EOLviewData: any) {
    this.store.dispatch(ProjectsActions.addEolViewModalData({ EOLviewData: EOLviewData }));
  }
  addEolViewModalDataChange(resetEOLviewData: any) {
    this.store.dispatch(
      ProjectsActions.addEolViewModalDataChange({ resetEOLviewData: resetEOLviewData })
    );
  }

  deleteOrgYearActions(process: any) {
    this.store.dispatch(ProjectsActions.deleteOrgYear({ process }));
  }

  orgReportingFailure(string: any) {
    this.store.dispatch(ProjectsActions.orgReportingError({ string }));
  }

  fillOrgYearData(data: any) {
    this.store.dispatch(ProjectsActions.fillOrgYearGridData({ data }));
  }

  clearFillDataComponentErr() {
    this.store.dispatch(ProjectsActions.clearFillDataComponentErr());
  }
  clearFillDataProductErr() {
    this.store.dispatch(ProjectsActions.clearFillDataProductErr());
  }

  updatePackageEOLRetail(process: any, action: any, processIndex?: any, nodeId?: any, colId?: any) {
    this.store.dispatch(
      ProjectsActions.updatePackageEOLRetail({ process, action, processIndex, nodeId, colId })
    );
  }

  updatePackageEOLConsumer(
    process: any,
    action: any,
    processIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      ProjectsActions.updatePackageEOLConsumer({ process, action, processIndex, nodeId, colId })
    );
  }

  patchEOLRetailList(data: any) {
    this.store.dispatch(ProjectsActions.patchEOLRetailDataOnInit({ data }));
  }

  patchEOLConsumerList(data: any) {
    this.store.dispatch(ProjectsActions.patchEOLConsumerDataOnInit({ data }));
  }

  updateProductMixAction(process: any, action: any, processIndex?: any, nodeId?: any, colId?: any) {
    this.store.dispatch(
      ProjectsActions.updateProductMixProcess({ process, action, processIndex, nodeId, colId })
    );
  }

  checkUpdateActionForProdLoss(check: boolean) {
    this.store.dispatch(ProjectsActions.checkUpdateForProdMix({ check }));
  }

  checkUpdateActionForOrganizationMapping(check: boolean) {
    this.store.dispatch(ProjectsActions.checkUpdateActionForOrganizationMapping({ check }));
  }

  checkUpdateActionForPInterpretation(check: boolean) {
    this.store.dispatch(ProjectsActions.checkUpdateActionForInterpretation({ check }));
  }
  checkUpdateActionForIngredient(check: boolean) {
    this.store.dispatch(ProjectsActions.checkUpdateActionForIngredient({ check }));
  }

  deleteProdMixData(process: any, action: any, processIndex?: any) {
    this.store.dispatch(ProjectsActions.deleteProductMixProcess({ process, action, processIndex }));
  }

  getProductMixList(productMixProcess: any) {
    this.store.dispatch(ProjectsActions.getProductMixList({ payload: productMixProcess }));
  }

  clearProductMixList() {
    this.store.dispatch(ProjectsActions.clearProductMixList());
  }

  clearProductMixError(errorStr: any) {
    this.store.dispatch(ProjectsActions.clearProductMixError({ errorStr }));
  }

  updateDataAnalysisTechnology(process: any, action: any, processIndex?: any, nodeId?: any) {
    this.store.dispatch(
      ProjectsActions.updateTechnologyInDataAnalysis({ process, action, processIndex, nodeId })
    );
  }

  getDataAnalysisData(fillDataAnalysisList: any) {
    this.store.dispatch(ProjectsActions.fillDataAnalysisListAction({ fillDataAnalysisList }));
  }

  updateComponentErrStr(errorStr: string) {
    this.store.dispatch(ProjectsActions.updateComponentErr({ errorStr }));
  }

  clearComponentErrStr() {
    this.store.dispatch(ProjectsActions.clearComponentErr());
  }

  checkUpdateActionForReuse(check: boolean) {
    this.store.dispatch(ProjectsActions.checkUpdateActionForReuse({ check }));
  }

  getOrganizationDataMap(organizationMapList: any) {
    this.store.dispatch(ProjectsActions.getOrganizationDataMap({ organizationMapList }));
  }

  getOrganizationPreferencesDataMap(organizationPreferencesMapList: any) {
    this.store.dispatch(
      ProjectsActions.getOrganizationPreferencesDataMap({ organizationPreferencesMapList })
    );
  }

  openImportNewAddProjectMaterial(
    data: any,
    scenarioId: any,
    id: any,
    actionLabel: any,
    isMaterial: any,
    pathName: any
  ) {
    this.store.dispatch(
      ProjectsActions.openImportNewAddProjectMaterialModal({
        data: data,
        scenarioId: scenarioId,
        actionLabel: actionLabel,
        id: id,
        isMaterial: isMaterial,
        pathName: pathName,
      })
    );
  }

  saveOrganizationPreferenceProcess(payload: any) {
    this.store.dispatch(ProjectsActions.saveOrganizationPreferenceProcess({ payload }));
  }
}
